module.exports = __webpack_public_path__ + "img/ico7.aad1f768.png";